import { render, staticRenderFns } from "./AllowedPaymentMethods.vue?vue&type=template&id=d0ec0bd6&"
import script from "./AllowedPaymentMethods.vue?vue&type=script&lang=js&"
export * from "./AllowedPaymentMethods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports